// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { UnderwriterDTO } from './underwriter-dto';

/**
 * 
 * @export
 * @interface PolicyTypeDTO
 */
export interface PolicyTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof PolicyTypeDTO
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyTypeDTO
     */
    coverLimit: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyTypeDTO
     */
    maxWeeksCover: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyTypeDTO
     */
    maxDuration: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyTypeDTO
     */
    coverType: PolicyTypeDTOCoverTypeEnum;
    /**
     * 
     * @type {UnderwriterDTO}
     * @memberof PolicyTypeDTO
     */
    underwriter: UnderwriterDTO;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyTypeDTOCoverTypeEnum {
    NEWTENANCY = 'NEW_TENANCY',
    EXISTINGTENANCY = 'EXISTING_TENANCY'
}



